<template>
  <el-row>
    <el-button
      @click="addEventDialog = true"
      style="margin-bottom: 10px;"
      type="primary"
    >
      {{ $t("m.quickEvent.addEvent") }}
    </el-button>
    <el-table :data="eventList" border stripe style="width: 80%">
      <el-table-column
        prop="name"
        :label="$t('m.quickEvent.eventName')"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="source"
        :label="$t('m.quickEvent.source')"
        width="120"
      >
        超管自建
      </el-table-column>
      <el-table-column
        prop="note"
        width="180"
        :label="$t('m.quickEvent.describe')"
      >
      </el-table-column>
      <el-table-column prop="sort" :label="$t('m.quickEvent.order')" width="80">
      </el-table-column>
      <el-table-column :label="$t('m.table.operation')">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            @click="deleteEventClick(scope.$index, scope.row)"
          >
            {{ $t("m.button.delete") }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="$t('m.quickEvent.addEvent')"
      width="40%"
      center
      :modal-append-to-body="false"
      :visible.sync="addEventDialog"
    >
      <el-form
        :model="addEventForm"
        ref="addEventForm"
        :rules="addEventForm.rules"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('m.quickEvent.eventName')" prop="name">
              <el-input
                v-model="addEventForm.name"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('m.quickEvent.order')" prop="sort">
              <el-input type="number" v-model="addEventForm.sort"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('m.quickEvent.describe')" prop="note">
              <el-input type="textarea" :rows="4" v-model="addEventForm.note">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addEventDialog = false">
          {{ $t("m.button.cancel") }}
        </el-button>
        <el-button type="primary" @click="addEventClick">
          {{ $t("m.button.save") }}
        </el-button>
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
export default {
  name: "eventManage",
  data() {
    return {
      eventList: [],
      addEventDialog: false,
      addEventForm: {
        name: "",
        sort: 0,
        note: "",
        rules: {
          name: [
            { required: true, message: "请输入事件名称", trigger: "blur" },
          ],
          sort: [{ required: true, message: "请输入顺序", trigger: "blur" }],
          note: [{ required: true, message: "请输入描述", trigger: "blur" }],
        },
      },
    };
  },
  mounted() {
    this.loadEventList();
  },
  methods: {
    addEventClick() {
      this.$refs["addEventForm"].validate((valid) => {
        if (valid) {
          console.info("表单验证通过");
          this.$confirm("确定创建该事件?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let params = new URLSearchParams();
              params.append("name", this.addEventForm.name);
              params.append("note", this.addEventForm.note);
              params.append("sort", this.addEventForm.sort);
              this.$http
                .post("/manage/event/add.do", params)
                .then(
                  function(resp) {
                    if (resp.data.success) {
                      this.$message.success("创建事件成功");
                      this.addEventDialog = false;
                      this.loadEventList();
                    } else {
                      this.$message.error("创建事件失败");
                    }
                  }.bind(this)
                )
                .catch((err) => {
                  console.info(err);
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
            });
        }
      });
    },
    deleteEventClick(index, event) {
      this.$confirm("确定删除该事件?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = new URLSearchParams();
          params.append("id", event.id);
          this.$http
            .post("/manage/event/delete.do", params)
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.$message.success("删除成功");
                  this.eventList.splice(index, 1);
                } else {
                  this.$message.error("删除失败");
                }
              }.bind(this)
            )
            .catch((err) => {
              console.info(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    loadEventList() {
      this.$http
        .get("/manage/event/list.do")
        .then(
          function(resp) {
            this.eventList = resp.data.data;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
  },
};
</script>

<style scoped></style>
